module.exports = __webpack_public_path__ + "img/icon-fish.f14cc97.webp";